import { ComponentType } from '../../registries/types/propTypes';
import type { FeaturedCardsProps } from '../../../components/FeaturedCardContainer/types/propsTypes';
import { CMSTransformerDataType } from '../../types/common';
import { displayCardTransformer } from './featured-display-card-transformer';
const transformFeaturedCards = (data: CMSTransformerDataType): FeaturedCardsProps => {
  const featuredCards = Array.isArray(data?.featured_display_cards_carousal)
    ? data?.featured_display_cards_carousal[0]
    : [];
  const getFeaturedList = (items: CMSTransformerDataType) =>
    items?.map((featuredCard: CMSTransformerDataType) => {
      const [featuredCardItem] = featuredCard.featured_card;
      return {
        ...displayCardTransformer(featuredCardItem),
      };
    });

  return {
    componentType: ComponentType.featured_card_container,
    displayTitle: featuredCards.title,
    heading: featuredCards.display_heading,
    viewAllLink: featuredCards.view_all,
    featuredCradsList: getFeaturedList(featuredCards.items),
  };
};

export default transformFeaturedCards;
